// color palette
const black = '#000'
const white = '#fff'

// blue "primary"
const lightBlue = '#e8f2ff'
const tintBlue = '#99c3f9'
const blue = '#0068ef'
const toneBlue = '#0055c4'
const darkBlue = '#049'
const shadeBlue = '#002f6d'

// green "secondary"
const lightGreen = '#ecf7ec'
const tintGreen = '#80d580'
const green = '#0a0'
const toneGreen = '#080'
const darkGreen = '#060'
const shadeGreen = '#040'

// red
const lightRed = '#fbebeb'
const tintRed = '#eb9999'
const red = '#c00'
const toneRed = '#b80000'
const darkRed = '#800'
const shadeRed = '#6d0000'

// orange
const lightOrange = '#fef2e7'
const tintOrange = '#faaf69'
const orange = '#f06f20'
const toneOrange = '#b74600'
const darkOrange = '#f06f20'
const shadeOrange = '#923800'

// yellow
const lightYellow = '#fff3c0'
const tintYellow = '#fee875'
const yellow = '#fedc2a'
const toneYellow = '#cbb022'
const darkYellow = '#806e0e'
const shadeYellow = '#665811'

// purple
const lightPurple = '#f5ebfa'
const tintPurple = '#c28ce0'
const purple = '#70b'
const tonePurple = '#5f0096'
const darkPurple = '#530083'
const shadePurple = '#410067'

// pink
const lightPink = '#fff0f5'
const tintPink = '#ffa0c4'
const pink = '#fe3e81'
const tonePink = '#d02962'
const darkPink = '#9e1f4b'
const shadePink = '#701b39'

// gray
const lightGray = '#f4f6f8'
const gray = '#4f6f8f'
const darkGray = '#364049'
const borderGray = '#c0cad5'
const buttonGray = '#edf0f3'

// text
const lightestText = white
const lightText = '#4f6f8f'
const tintText = '#3f5972'
const text = '#001833'
const darkText = '#001023'
const headingText = '#003c8a'

// highlight
const lightHighlight = '#d0f1ac'
const tintHighlight = '#b9ea85'
const highlight = '#8cdd36'
const toneHighlight = '#66be20'
const darkHighlight = '#2e9000'
const shadeHighlight = '#017000'

// background
const lightestBackground = white
const lightBackground = '#f4f6f8'
const tintBackground = '#d5dce4'
const background = buttonGray // '#4f6f8f'
const toneBackground = '#879db3'
const darkBackground = gray // '#283848'
const shadeBackground = '#354b60'
const darkestBackground = '#001833'

// border
const lightBorder = '#eceff2'
const tintBorder = '#e0e5ea'
const border = '#c0cad5'
const toneBorder = '#868d95'
const darkBorder = '#5e6872'
const shadeBorder = '#1a1d20'

/**
 * @public
 */
export const colors = {
  black,
  white,

  lightBlue,
  tintBlue,
  blue,
  toneBlue,
  darkBlue,
  shadeBlue,

  lightGreen,
  tintGreen,
  green,
  toneGreen,
  darkGreen,
  shadeGreen,

  lightRed,
  tintRed,
  red,
  toneRed,
  darkRed,
  shadeRed,

  lightOrange,
  tintOrange,
  orange,
  toneOrange,
  darkOrange,
  shadeOrange,

  lightYellow,
  tintYellow,
  yellow,
  toneYellow,
  darkYellow,
  shadeYellow,

  lightPurple,
  tintPurple,
  purple,
  tonePurple,
  darkPurple,
  shadePurple,

  lightPink,
  tintPink,
  pink,
  tonePink,
  darkPink,
  shadePink,

  lightGray,
  gray,
  darkGray,
  borderGray,
  buttonGray,

  lightestText,
  lightText,
  tintText,
  text,
  darkText,
  headingText,

  lightHighlight,
  tintHighlight,
  highlight,
  toneHighlight,
  darkHighlight,
  shadeHighlight,

  lightestBackground,
  lightBackground,
  tintBackground,
  background,
  toneBackground,
  darkBackground,
  shadeBackground,
  darkestBackground,

  lightBorder,
  tintBorder,
  border,
  toneBorder,
  darkBorder,
  shadeBorder,
}
